import {forwardRef, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {getCurrentLanguageKey} from "../utils/util";

const UserProgressReport = forwardRef((props, ref) => {


    const { viewMode } = props;

    const {t, i18n: { changeLanguage }} = useTranslation();



    useEffect(() => {

        changeLanguage(getCurrentLanguageKey());

    }, []);

    return (<>
        {viewMode !== "view" && (
            <div className="bg-light p-2">
                {t('report-progress')}
            </div>
        )}
    </>)

});

export default UserProgressReport;
